module.exports = __webpack_public_path__ + "img/gift_bg_popup_1.ad4336a.png";